import React from "react";

export const ArrowDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="#002E19" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
